import { RetailerApiClient } from '@/services/RetailerApiClient.js'

export default {

  getCustomerByTckn(machineId, tckn) {
    return RetailerApiClient.get(`machines/consumer-goods-customer-info/${machineId}/customer-lookup`, {
      params: { payload: { tckn } }
    })
  },

  verifyPhone(machineId, { tckn, phone, forceRefresh = false }) {
    return RetailerApiClient.post(`machines/consumer-goods-customer-info/${machineId}/verify-phone`, {
      payload: { tckn, phone, forceRefresh }
    })
  },

  resume(machineId) {
    return RetailerApiClient.get(`machines/consumer-goods-customer-info/${machineId}/resume`)
  },

  getStatus(machineId) {
    return RetailerApiClient.get(`machines/consumer-goods-customer-info/${machineId}/status`)
  },

  requestCustomerInfoLink(machineId, payload) {
    return RetailerApiClient.post(`machines/consumer-goods-customer-info/${machineId}/customer-info-link-requested`, {
      payload
    })
  }
}
